
import { useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../baseurl"; 
import { useToast } from "../admincomponents/AdminToast";

export default function AdminForgotPassword() {
  const navigate = useNavigate();
  const toast = useToast();
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${BASE_URL}/admin/forgot-password`, { email });
      toast({
        variant: "success",
        title: "OTP sent",
        description: data.message || "Check your inbox for the reset code.",
      });
      setSubmitted(true);
      setTimeout(() => navigate("/admin/reset-password", { state: { email } }), 1200);
    } catch (error) {
      const message =
        error.response?.data?.message ||
        "Something went wrong. Please try again.";

      toast({
        variant: "error",
        title: "Something went wrong",
        description: message,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full min-h-screen bg-gray-50 flex items-center justify-center px-6">
      <div className="w-full max-w-[420px] bg-white border border-gray-200 rounded-lg shadow-sm p-10">
        <div className="flex flex-col items-center mb-8">
          <div className="w-14 h-14 rounded-full bg-teal-500 flex items-center justify-center mb-4">
            <svg
              width="26"
              height="26"
              viewBox="0 0 24 24"
              fill="none"
              className="text-white"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 12a4 4 0 100-8 4 4 0 000 8zM4 20a8 8 0 0116 0"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <h1 className="text-gray-800 font-semibold text-[24px]">Forgot Password</h1>
          <p className="text-gray-500 text-[14px] mt-1 text-center">
            {submitted
              ? "Check your inbox for reset instructions"
              : "Reset your admin account password"}
          </p>
        </div>

        {!submitted ? (
          <form onSubmit={handleSubmit} className="flex flex-col gap-6">
            <div>
              <label className="block text-gray-600 text-sm font-medium mb-2">
                Email
              </label>
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="you@futuraresearch.com"
                className="w-full bg-gray-50 border border-gray-300 rounded-md px-4 py-3 text-gray-800 text-sm focus:outline-none focus:border-teal-500 focus:ring-1 focus:ring-teal-500"
              />
              <p className="text-gray-400 text-xs mt-2">
                We'll send a code to reset your password if an admin account exists for this email.
              </p>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-teal-500 hover:bg-teal-600 disabled:bg-teal-300 disabled:cursor-not-allowed text-white font-semibold text-sm rounded-md py-3 transition-colors"
            >
              {loading ? "Sending..." : "Send Reset Code"}
            </button>
          </form>
        ) : (
          <div className="flex flex-col items-center text-center gap-4">
            <div className="w-14 h-14 rounded-full bg-teal-50 border border-teal-200 flex items-center justify-center">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="text-teal-600" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <p className="text-gray-500 text-sm">
              If an admin account with <span className="text-gray-800 font-medium">{email}</span> exists, a reset code is on its way.
            </p>
          </div>
        )}

        <p className="text-center text-gray-500 text-sm mt-6">
          Remembered it?{" "}
          <NavLink to="/admin/login" className="text-teal-600 hover:text-teal-700 font-medium">
            Back to sign in
          </NavLink>
        </p>
      </div>
    </div>
  );
}